import { Mutation } from 'vuex';
import { IModuleState } from './types';

// 后台模型类型
export const setBackTypes: Mutation<IModuleState> = (state, payload) => {
  state.backTypes.data = payload.data;
  state.backTypes.raw = payload.data;
  state.backTypes.loading = payload.loading;
};

// 实例类型
export const setEntityTypes: Mutation<IModuleState> = (state, payload) => {
  state.entityTypes.data = payload.data;
  state.entityTypes.raw = payload.data;
  state.entityTypes.loading = payload.loading;
};

// 平面图类型
export const setFlagImageTypes: Mutation<IModuleState> = (state, payload) => {
  state.flagImageTypes.data = payload.data;
  state.flagImageTypes.raw = payload.data;
  state.flagImageTypes.loading = payload.loading;
};

// 过滤项类型
export const setFilterTypes: Mutation<IModuleState> = (state, payload) => {
  state.filterTypes.data = payload.data;
  state.filterTypes.raw = payload.data;
  state.filterTypes.loading = payload.loading;
};

// 全部表面材料类型
export const setMaterialFullTypes: Mutation<IModuleState> = (state, payload) => {
  state.materialFullTypes.data = payload.data;
  state.materialFullTypes.raw = payload.data;
  state.materialFullTypes.loading = payload.loading;
};

// 表面材料类型
export const setMaterialTypes: Mutation<IModuleState> = (state, payload) => {
  state.materialTypes.data = payload.data;
  state.materialTypes.raw = payload.data;
  state.materialTypes.loading = payload.loading;
};

// 物料状态
export const setStatusTypes: Mutation<IModuleState> = (state, payload) => {
  state.statusTypes.data = payload.data;
  state.statusTypes.raw = payload.data;
  state.statusTypes.loading = payload.loading;
};

// 表面材料可摆放类型
export const setSurfaceTypes: Mutation<IModuleState> = (state, payload) => {
  state.surfaceTypes.data = payload.data;
  state.surfaceTypes.raw = payload.data;
  state.surfaceTypes.loading = payload.loading;
};

// 价格单位
export const setUnitTypes: Mutation<IModuleState> = (state, payload) => {
  state.unitTypes.data = payload.data;
  state.unitTypes.raw = payload.data;
  state.unitTypes.loading = payload.loading;
};

// 灯具配置类型
export const setLuminorConfigTypes: Mutation<IModuleState> = (state, payload) => {
  state.luminorConfigTypes.data = payload.data;
  state.luminorConfigTypes.loading = payload.loading;
};

// 价格弹窗
export const setDialogPrice: Mutation<IModuleState> = (state, payload) => {
  state.dialogPrice.data = payload.data || null;
  state.dialogPrice.visible = payload.visible || false;
  state.dialogPrice.loading = payload.loading || false;
};

// 导出弹窗
export const setDialogExport: Mutation<IModuleState> = (state, payload) => {
  state.dialogExport.data = payload.data || null;
  state.dialogExport.visible = payload.visible || false;
  state.dialogExport.loading = payload.loading || false;
};

// 导入弹窗
export const setDialogImport: Mutation<IModuleState> = (state, payload) => {
  state.dialogImport.data = payload.data || null;
  state.dialogImport.visible = payload.visible || false;
  state.dialogImport.loading = payload.loading || false;
};
